import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ListItem,
    Divider,
} from '../../material-ui';
import MNineAvatar from '../view/MNineAvatar';



class ChatGroupItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onListItemClick = () => {
        this.props.onClick && this.props.onClick();
    }

    render() {
        const { classes, data, end } = this.props;
        return (
            <ListItem disableRipple button onClick={() => this._onListItemClick()} className={classes.root}>
                <Grid container direction='column'>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 8 }}>
                        <MNineAvatar imgs={data.headurls} size={40} />
                        <Typography className={classes.name}>{data.titleName}</Typography>
                    </Grid>
                    <Grid container direction='column' justifycontent='flex-end' className={classes.content}>
                        <Divider className={end ? classes.divider1 : classes.divider}></Divider>
                    </Grid>
                </Grid>
            </ListItem>
        );
    }
}
export default withStyles((theme) => ({
    root: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: 0,
        height: 60,
    },
    menuIcon: {
        width: 40,
        height: 40,
    },
    content: {
        flex: 1,
    },
    divider: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: 'calc(100% - 56px)',
        marginLeft: 56,
        marginTop: 0
    },
    divider1: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: '100%',
        marginTop: 8
    },
    name: {
        color: '#0D0D0D',
        fontSize: 14,
        fontWeight: 'bold',
        marginLeft: 8,
        flex: 1,
    }
}))(ChatGroupItem);
